import React from 'react';
import { FormOptionsContext } from '$/components/ui/Form';
import { useHasChanged } from './useHasChanged';

interface FormImageUploadProps {
  fieldName: string;
  isUploading: boolean;
  skip?: boolean;
}

/*
  Track image is uploading or not
  */
const useFormImageUpload = ({
  fieldName,
  isUploading,
  skip = false,
}: FormImageUploadProps): void => {
  // context for updating image upload state
  const { imageUpload, setImageUpload } = React.useContext(FormOptionsContext);

  // change form uploading state input
  const isUploadingChanged = useHasChanged([isUploading]);
  React.useEffect(() => {
    if (!isUploadingChanged) return;

    if (!skip) {
      setImageUpload({
        ...imageUpload,
        [fieldName]: isUploading,
      });
    }
  }, [fieldName, imageUpload, isUploading, isUploadingChanged, setImageUpload, skip]);
};

export default useFormImageUpload;
